import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const mainClub = lazy(() => import('../../container/clubs/main-club'));
const subClub = lazy(() => import('../../container/clubs/sub-club'));
const studentMembershipClub = lazy(() => import('../../container/clubs/student-membership-club'));

const Clubs = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/mainClub`} component={mainClub}/>
            <Route path={`${path}/subClub`} component={subClub}/>
            <Route path={`${path}/studentMembershipClub`} component={studentMembershipClub}/>
        </Switch>
    );
};

export default Clubs;